module.exports = __webpack_public_path__ + "static/img/1.e5ba060.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/1.png
// module id = DGaT
// module chunks = 0